import { LogEvent, LogError } from '../types';
import { getUserEmail } from '.';

export async function formatLogEvent(event: LogEvent | LogError) {
  const { message, data } = event;
  const error = event['error'];
  const formattedError = {};
  if (error) {
    formattedError['error'] = error;
    formattedError['stack'] = error?.stack;
    formattedError['kind'] = error?.kind;
    formattedError['errorName'] = error?.name;
    formattedError['errorMsg'] = error?.message;
  }
  const formattedEvent = {
    message,
    data: { ...data, error: formattedError },
    userEmail: await getUserEmail(),
  };
  return formattedEvent;
}
